import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const SkeletonWrapper = styled.div`
  position: absolute;
  inset: 0;
`;
